export default __webpack_public_path__ + "static/media/Headdress of the Wells of Night.19758f1b.jpg";